import { call, put, select } from 'redux-saga/effects'
import { Saga } from 'app-types'

import { OpenApiInterface } from '../../api/requests/openApi'
import { Response, parseErrors } from '../../api/api'
import { ResponseError } from '../../utils/errors'

import { paymentActions } from '../../redux'
import { getPennyPaymentForm } from './payment.mappers'

export function* pennyPaymentConfirm(
  api: OpenApiInterface,
  { payload: { error, success } }: any
): Saga {
  const response = yield call(api.pennyPaymentConfirm)

  if (response.responseStatus === Response.ok) {
    yield call(success)
  } else if (response.responseStatus === Response.serverErrorRetry) {
    error({ type: response.responseStatus })
  } else {
    throw new ResponseError('payment - pennyPaymentConfirm saga', response)
  }
}
export function* fetchPennyPayment(api: OpenApiInterface, { payload: { error } }: any): Saga {
  const response = yield call(api.getPennyPayment)

  if (response.responseStatus === Response.ok) {
    const data = response.data
    yield put(paymentActions.savePennyPayment(data))
  } else if (response.responseStatus === Response.serverErrorRetry) {
    error({ type: response.responseStatus })
  } else {
    throw new ResponseError('payment - fetch Penny Payment saga', response)
  }
}

export function* submitAccountNumber(api: OpenApiInterface, { payload: { success, error } }: any) {
  const data = yield select(getPennyPaymentForm)

  const response = yield call(api.saveAccountNumber, data)

  if (response.responseStatus === Response.ok) {
    yield call(success)
  } else if (response.responseStatus === Response.dataError) {
    error({ type: response.responseStatus, errors: parseErrors(response) })
  } else if (response.responseStatus === Response.serverErrorRetry) {
    error({ type: response.responseStatus })
  } else {
    throw new ResponseError('payment - submit Account Number', response)
  }
}
